export enum PreviewType {
  MEDIA = "preview-media",
  DOCUMENT = "preview-document",
  FAILED = "upload-failed",
  PREVIEW = "preview-component",
}

export type AttributeType =
  | "path"
  | "name"
  | "thumbnail"
  | "fileid"
  | "mimetype";
export const acceptAttribute: AttributeType[] = [
  "path",
  "name",
  "fileid",
  "mimetype",
  "thumbnail",
];
export const PREVIEW_DOCUMENT: PreviewType = PreviewType.DOCUMENT;
export const PREVIEW_MEDIA: PreviewType = PreviewType.MEDIA;
export const PREVIEW_COMPONENT: PreviewType = PreviewType.PREVIEW;
export const UPLOAD_FAILED: PreviewType = PreviewType.FAILED;
export const ARBO_EMOJI = "arbo-emoji";
